export const getMomentLocaleForCampaign = (country: string): string => {
  switch (country.toLowerCase()) {
    case 'gb': return 'en-GB'
  }

  if (country) {
    return country.toLowerCase()
  }

  return 'en-GB'
}
